import React from "react";
import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import { UniversalImg2, PlayIcon, UniversalImg4, Member1Img, Member2Img, Member3Img, Member4Img } from "../../Constant/Index";
import AOS from 'aos';
const AboutUs = () => {
    const Members = [
        {
            Image: Member1Img,
            Name: "John Doe",
            Post: "Psycotherapy - Chicago, IL"
        },
        {
            Image: Member2Img,
            Name: "Emily Clark",
            Post: "Psycotherapy - Chicago, IL"
        },
        {
            Image: Member3Img,
            Name: "Jane Jones",
            Post: "Psycotherapy - Chicago, IL"
        },
        {
            Image: Member4Img,
            Name: "Peter Williams",
            Post: "Psycotherapy - Chicago, IL"
        },
    ];
    React.useEffect(() => {
        AOS.init(); // Initialize AOS in your component
    }, []);
    return (
        <>
            <Header />
            <UniversalBanner heading="About Us" />
            <section className="text-with-image">
                <div className="container">
                    <div className="data-start-here">
                        <div className="row">
                            <div className="col-lg-7 col-md-6 pe-xl-5" data-aos="fade-right" data-aos-duration="1300">
                                <div className="d-flex justify-content-center h-100 flex-column h-100">
                                    <div className="text-here">
                                        <div className="top-heading">
                                            <span className="small-heading">Objective</span>
                                            {/* <h2 className="lg-heading">Psychotherapy and Counselling</h2> */}
                                            <h2 className="lg-heading mb-lg-4">Best Therapist at your Service</h2>
                                        </div>
                                        <div className="for-space pe-xl-5">
                                            <p className="text mb-lg-4 pe-lg-5 me-lg-5">We understand that seeking help for mental health issues can be intimidating, and that is why we strive to create a welcoming and non-judgmental atmosphere where clients feel comfortable and supported. Whether you are struggling with anxiety, depression, trauma, or any other mental health concern, we are here to provide you with the tools and support you need to move forward and lead a fulfilling, meaningful life</p>
                                        </div>
                                        <Link className="btn mt-2" to="/objective">Learn more</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-6 ps-lg-0 pt-5 pt-md-0" data-aos="fade-left" data-aos-duration="1300">
                                <figure className='with-hover '>
                                    <img src={UniversalImg2} alt="" className="img-fluid with-boxes" />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="vision-mision overflow-hidden">
                <div className="continer-fluid">
                    <div className="row">
                        <div className="col-md-6 px-0 h-100">
                            <div className="vision-start single-part primary-text text-center" data-aos="fade-down" data-aos-duration="1100">
                                <div className="col-lg-10 mx-auto">
                                    <div className="top-heading">
                                        <span className="small-heading">MISSION</span>
                                        <h2 className="lg-heading">Our Mission</h2>
                                    </div>
                                    <div className="body-text">
                                        <p className="text">We understand that seeking help for mental health issues can be intimidating, and that is why we strive to create a welcoming and non-judgmental atmosphere where clients feel comfortable and supported. Whether you are struggling with anxiety, depression, trauma, or any other mental health concern, we are here to provide you with the tools and support you need to move forward and lead a fulfilling, meaningful life</p>
                                    </div>
                                    <div className="end-text">
                                        <span className="text mediam-font d-block width-fit mb-3 mx-auto">-CEO Lorem Ipsum</span>
                                        <Link to="/mission" className="text mediam-font btn d-block width-fit mx-auto decoration sm-text">Learn More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 px-0 h-100">
                            <div className="mission-start single-part primary-text text-center" data-aos="fade-up" data-aos-duration="1100">
                                <div className="col-lg-10 mx-auto">

                                    <div className="top-heading">
                                        <span className="small-heading">VISION</span>
                                        <h2 className="lg-heading">Our Vision</h2>
                                    </div>
                                    <div className="body-text">
                                        <p className="text">We understand that seeking help for mental health issues can be intimidating, and that is why we strive to create a welcoming and non-judgmental atmosphere where clients feel comfortable and supported. Whether you are struggling with anxiety, depression, trauma, or any other mental health concern, we are here to provide you with the tools and support you need to move forward and lead a fulfilling, meaningful life</p>
                                    </div>
                                    <div className="end-text">
                                        <span className="text mediam-font d-block width-fit mb-3 mx-auto">-CEO Lorem Ipsum</span>
                                        <Link to="/vision" className="text mediam-font btn   d-block width-fit mx-auto decoration sm-text">Learn More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="text-with-image">
                <div className="container">
                    <div className="data-start-here">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 pe-lg-0 order-1 order-md-0 pt-5 pt-md-0" data-aos="fade-right" data-aos-duration="1100">
                                <div className="video-here d-flex h-100 align-items-center">
                                    <figure className='video-img with-hover '>
                                        <img src={UniversalImg4} alt="" className="img-fluid with-boxes" />
                                        <button className='play-btn' data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                            <img src={PlayIcon} alt="" />
                                        </button>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 ps-xl-5  d-flex  flex-column justify-content-center" data-aos="fade-left" data-aos-duration="1100">
                                <div className="text-here ps-xl-2 ">
                                    <h2 className="lg-heading mb-lg-4">History</h2>
                                    <p className="text mb-lg-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                    <Link className="btn mt-2" to="/history">Learn more</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="our-team">
                <div className="container">
                    <div className="our-team-start">
                        <div className="top-heading text-center">
                            <span className="small-heading">Our Team</span>
                            <h2 className="lg-heading">Board Members</h2>
                        </div>
                        <div className="mebmers-list">
                            <div className="row">
                                {Members.map((member, index) => (
                                    < div className={`col-lg-3 col-md-6 col-sm-6 ps-lg-4 py-4 py-lg-0 ${(index === 0) ? 'pt-0' : '' }`} data-aos="fade-right" data-aos-duration="1100">
                                        <div className="single-member ps-1">
                                            <figure className="member-img">
                                                <img src={member.Image} alt="" className="img-fluid w-100" />
                                            </figure>
                                            <div className="member-data text-center">
                                                <h4 className="sm-heading mb-0">{member.Name}</h4>
                                                <div className="text lg-text">{member.Post}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
            <section className="video-modal">
                {/* <!-- Modal --> */}
                <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg  modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="staticBackdropLabel">Video</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                {/* <iframe width="100%" height="500px" src="https://www.youtube.com/embed/37V3b39_EXw?si=nmkhiHyqUz4olxap" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
                                <video class="w-100" controls>
                                    <source src="https://vod-progressive.akamaized.net/exp=1695222249~acl=%2Fvimeo-prod-skyfire-std-us%2F01%2F1000%2F16%2F405003243%2F1733614317.mp4~hmac=239b623ba69099b336b921b45f4b1257555e26abe3179d3a5433c7021d1affde/vimeo-prod-skyfire-std-us/01/1000/16/405003243/1733614317.mp4" type="video/mp4" /></video>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default AboutUs;